<template>
  <div class="panel-container">
    <!-- 头部容器 -->
    <div class="header-container">
      <!-- 标题 -->
      <div class="title-container">
        <div class="symbol-icon"></div>
        <span class="title-text">{{ $str.getKey('收益管理/充放电统计') }}</span>
      </div>
      <!-- 操作按钮 -->
      <div class="btns-container">
      </div>
    </div>
    <!-- 主体容器 -->
    <div class="main-container">
      <!-- 电量统计图 -->
      <v-chart 
        v-if="panelData.kwhOption" 
        :key="`kwh-${chartData?.kwh?.length || 0}`"
        class="chart-container" 
        :option="panelData.kwhOption" 
        :autoresize="true" 
      />
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, watch, onMounted, onBeforeUnmount } from "vue"
import dayjs from 'dayjs';
import { getChartOption as getKwhChartOption } from "./kwhChartOptions.js"

const $str = window.$str;

/** 设置组件配置项 */
defineOptions({
  name: "chartPanel"
});

/** 接收父组件信息 */
const props = defineProps({
  chartData: {
    type: Object,
    default: {
      income: [],
      kwh: [],
      incomeModel: 1,
    }
  },
});


const panelData = reactive({
  kwhOption: getKwhChartOption(props.chartData?.incomeModel, props.chartData?.kwh || []),
})




initPanel();


const isMounted = ref(false);

onMounted(() => {
  isMounted.value = true;
})

// 同时监听 kwh 和 incomeModel 的变化
const stopWatch1 = watch(() => props.chartData?.kwh, (nv) => {
  if (isMounted.value && nv !== undefined) {
    panelData.kwhOption = getKwhChartOption(props.chartData?.incomeModel, nv);
  }
}, { immediate: false })

const stopWatch2 = watch(() => props.chartData?.incomeModel, (nv) => {
  if (isMounted.value && props.chartData?.kwh !== undefined) {
    panelData.kwhOption = getKwhChartOption(nv, props.chartData?.kwh);
  }
}, { immediate: false })

onBeforeUnmount(() => {
  isMounted.value = false;
  stopWatch1();
  stopWatch2();
})





// /** ====== [业务：功能方法] =================================================================== */
/** 初始化面板 */
function initPanel() {

}



/** ====== [辅助：功能方法] =================================================================== */






</script>
<style lang="scss" scoped>
.panel-container {
  --page-top: 12px;
  --header-hight: 50px;
  & {
    width: 100%;
    height: calc(100% - var(--page-top));
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.63) 0%, rgba(255, 255, 255, 0.42) 100%);
    border-radius: 20px;
    border: 0.5px solid rgba(255, 255, 255, 1);
    backdrop-filter: blur(10px);
    // margin-top: var(--page-top);
    padding: 10px;
  
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .header-container {
    width: 100%;
    height: var(--header-hight);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-container {
      max-width: 50%;
      height: 100%;
      padding-left: 0;
      display: flex;
      align-items: center;
      gap: 6px;
      .title-text {
        color: #2E2E2E;
        font-family: "HarmonyOS Sans SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }

    .btns-container {
      max-width: 50%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      // gap: 10px;
    }
  }

  .main-container {
    & {
      width: 100%;
      flex: 1;
      min-height: 0;
      box-sizing: border-box;
      border: 0.5px solid rgba(255, 255, 255, 0.5);
      border-radius: 12px;

      display: flex;
      flex-direction: column;
    }

    .chart-container {
      width: 100%;
      flex: 1;
      min-height: 200px;
      height: 100%;
      background: transparent;
      padding: 10px;
      box-sizing: border-box;
    }

  }

}


// 充放电统计图 tooltip 布局优化，参考截图的卡片布局（不改颜色）
::v-deep .chart-tooltip {
  padding: 12px 16px !important;
  border-radius: 8px !important;
}

::v-deep .chart-tooltip__time {
  margin-bottom: 8px;
  font-family: "HarmonyOS Sans SC";
  font-size: 14px;
}

::v-deep .chart-tooltip__items-container {
  &.kwh-20250222 {
    display: flex;
    gap: 20px;
    align-items: flex-start;
  }
}

::v-deep .chart-tooltip__charge-container,
::v-deep .chart-tooltip__discharge-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

::v-deep .chart-tooltip__series {
  display: flex;
  align-items: center;
  justify-content: flex-start; // 指标整体左对齐
  padding: 4px 8px;
  border-radius: 6px;
  // 保持使用当前背景色（由 tooltip 背景控制），只做布局
}

::v-deep .chart-tooltip__series-name,
::v-deep .chart-tooltip__value {
  font-family: "HarmonyOS Sans SC";
  font-size: 13px;
  margin-left: 4px;
}

::v-deep .chart-tooltip__point {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 4px;
}

</style>
